module.exports = __webpack_public_path__ + "img/8.b17368cd.jpg";